import FlexColumn from "../../layout/Flexbox/FlexColumn";
import FlexRow from "../../layout/Flexbox/FlexRow";
import Modal from "../Modal/Modal";
import Cookies from "universal-cookie";
import InventoryItem from "../../../../utils/game/mechanics/InventoryItem";
import InventoryItemList from "../../../../pages/character/components/InventoryItemCollection/InventoryItemList";
import InventoryItemDynamicCollection from "../../../../pages/character/components/InventoryItemCollection/InventoryItemDynamicCollection";
import InventoryItemTransferContext from "../../../../utils/sys/InventoryItemTransferContext";
import Spinner from "../../system/Spinner/Spinner";
import { useContext, useEffect, useRef, useState } from "react";
import { useGetItemBankItemList } from "../../../../net/ItemBankManagement";

import "./ItemBankModal_style.css";

type Props = {
    isVisible?: boolean;
    onClose?: () => void;
};

function ItemBankModalContent(props: Props): JSX.Element {
    const inventoryItemTransferContext = useContext(
        InventoryItemTransferContext
    );
    const [loadItemBankItemList, isLoadingItemBankItemList] =
        useGetItemBankItemList();
    const [itemList, setItemList] = useState<Array<InventoryItem>>([]);
    const inventoryRef = useRef<Element>(null);

    const cookies = new Cookies();

    useEffect(() => {
        loadItemBankItemList({
            variables: { token: cookies.get("session_token") },
            onComplete: (result) => {
                setItemList(result);
            },
            onError: (error) => {},
        });
    }, []);

    return (
        <>
            {isLoadingItemBankItemList() ? (
                <Spinner />
            ) : (
                <InventoryItemDynamicCollection
                    id="ItemBankInventory"
                    items={itemList}
                    expanded={true}
                    contentAreaClassName="item-content-area"
                    isEditable={true}
                    itemRestrictor={(item) => item === null}
                    onItemChanged={(item) => {}}
                />
            )}
        </>
    );
}

export default function ItemBankModal(props: Props): JSX.Element {
    return (
        <Modal
            contentClassName="item-bank-modal"
            header="Item Bank"
            isVisible={props.isVisible}
            onClose={props.onClose}
        >
            <ItemBankModalContent />
        </Modal>
    );
}
